import Color from 'color'
import SDDarkBackground from 'src/assets/ThemeImages/SDDark/login-bg.jpg'
import SDDarkLoginLogo from 'src/assets/ThemeImages/SDDark/login-logo.svg'
import SDDarkTransLogo from 'src/assets/ThemeImages/SDDark/login-trans-logo.png'
import SDLightBackground from 'src/assets/ThemeImages/SDLight/login-bg.jpg'
import SDLightLoginLogo from 'src/assets/ThemeImages/SDLight/login-logo.svg'
import SDLightTransLogo from 'src/assets/ThemeImages/SDLight/login-trans-logo.png'

interface ThemeConfig {
  display: string
  key: string
  isDark: boolean
  default?: boolean
  isActive?: boolean | (() => boolean)
  colors: {
    info: string
    nav1: string
    nav2: string
  }

  loginBackgroundImage?: string
  loginTransLogoImage?: string
  loginLogoImage?: string
}

export const themeConfigs: ThemeConfig[] = [
  {
    display: 'Light',
    key: 'sd_light',
    isDark: false,
    default: true,
    colors: {
      info: '#002B58',
      nav1: '#19304B',
      nav2: Color('#19304B').lighten(0.8).hex(),
    },
    loginLogoImage: SDLightLoginLogo,
    loginBackgroundImage: SDLightBackground,
    loginTransLogoImage: SDLightTransLogo,
  },
  {
    display: 'Dark',
    key: 'sd_dark',
    isDark: true,
    colors: {
      info: '#59cfff',
      nav1: '#19304B',
      nav2: Color('#19304B').lighten(0.8).hex(),
    },
    loginLogoImage: SDDarkLoginLogo,
    loginBackgroundImage: SDDarkBackground,
    loginTransLogoImage: SDDarkTransLogo,
  },
]
